module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!./UserListing.js"));
	}, "admin");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/users/UserListing.js
// module id = 1997
// module chunks = 4